module.exports = __webpack_public_path__ + "static/media/bill-approval-flow.941ce585.svg";